import { jsx as _jsx } from "react/jsx-runtime";
import reduce from 'lodash/reduce';
import React from 'react';
import Linkify from 'react-linkify';
class SimpleText extends React.Component {
    render() {
        return _jsx(Linkify, { properties: { target: '_blank' }, children: this._breakLine(this.props.content) });
    }
    _breakLine(text = '') {
        const regex = /(?:\r)?\n/g;
        const breakedLine = reduce(text.split(regex), (result, line) => {
            return result.concat(line, _jsx("br", {}));
        }, []);
        breakedLine.pop();
        return breakedLine.map((value, index) => _jsx(React.Fragment, { children: value }, `break-line-${index}`));
    }
}
export default SimpleText;
